var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeaderCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5H5.44483C5.71697 4.5 5.85304 4.5 5.96254 4.5468C6.05903 4.58804 6.14081 4.65437 6.19811 4.73787C6.26314 4.83263 6.28238 4.95861 6.32087 5.21055L6.84442 8.63793M6.84442 8.63793L8.00799 16.6359C8.15564 17.6509 8.22947 18.1584 8.48892 18.5404C8.71755 18.877 9.04531 19.1446 9.43276 19.3111C9.87247 19.5 10.4201 19.5 11.5154 19.5H20.9818C22.0244 19.5 22.5457 19.5 22.9718 19.3246C23.3474 19.1699 23.6696 18.9205 23.9024 18.6044C24.1664 18.2458 24.2639 17.7669 24.459 16.8091L25.9232 9.62037C25.9918 9.28325 26.0262 9.11469 25.9764 8.98293C25.9328 8.86735 25.8467 8.77002 25.7334 8.70829C25.6043 8.63793 25.4208 8.63793 25.0539 8.63793H6.84442Z",
    stroke: "#222222",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 26.5C11.8284 26.5 12.5 25.8284 12.5 25C12.5 24.1716 11.8284 23.5 11 23.5C10.1716 23.5 9.5 24.1716 9.5 25C9.5 25.8284 10.1716 26.5 11 26.5Z",
    stroke: "#222222",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26.5C21.8284 26.5 22.5 25.8284 22.5 25C22.5 24.1716 21.8284 23.5 21 23.5C20.1716 23.5 19.5 24.1716 19.5 25C19.5 25.8284 20.1716 26.5 21 26.5Z",
    stroke: "#222222",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeaderCart);
export default __webpack_public_path__ + "static/media/icon_header_cart.c74cf3078eba8b8616e0d338ed07dce0.svg";
export { ForwardRef as ReactComponent };